import React, { useState } from 'react';
import { Moon, Sun, Globe } from 'lucide-react';
import { useLang } from '../context/langcontext'; // ✅ import global language context

const Toggles = () => {
  const [darkMode, setDarkMode] = useState(false);
  const { lang, toggleLang } = useLang(); // ✅ use global lang + toggle

  // Toggle dark/light mode
  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
    document.body.classList.toggle('light-mode');
  };

  return (
    <div className="toggle-container">
      {/* Dark mode toggle */}
      <button
        className={`toggle-btn ${darkMode ? 'active' : ''}`}
        onClick={toggleDarkMode}
        aria-pressed={darkMode}
        aria-label="Toggle dark/light mode"
      >
        {darkMode ? <Sun size={20} /> : <Moon size={20} />}
      </button>

      {/* Language toggle */}
      <button
        className={`toggle-btn ${lang === 'ar' ? 'active' : ''}`} // ✅ highlight active when Arabic
        onClick={toggleLang}
        aria-label="Toggle language"
      >
        <Globe size={20} />
      </button>
    </div>
  );
};

export default Toggles;
